{
  "difficulty": {
    "beginner": "Iniciante",
    "intermediate": "Intermediário",
    "advanced": "Avançado"
  },
  "card": {
    "completed": "Concluído",
    "courseCount_one": "{{count}} curso",
    "courseCount_zero": "{{count}} cursos",
    "courseCount_other": "{{count}} cursos",
    "progress": "Progresso:",
    "courseOf": "Curso {{current}} de {{total}}",
    "review": "Revisar",
    "continue": "Continuar",
    "startTrail": "Iniciar Trilha"
  },
  "roadmap": {
    "trailProgress": "Progresso da Trilha:",
    "coursesCompleted_one": "{{completed}} de {{count}} curso concluído",
    "coursesCompleted_zero": "{{completed}} de {{count}} cursos concluídos",
    "coursesCompleted_other": "{{completed}} de {{count}} cursos concluídos",
    "required": "Obrigatório",
    "courseProgress": "Progresso do curso:",
    "courseNumber": "Curso {{number}}",
    "startCourse": "Iniciar Curso",
    "completedTitle": "🎉 Parabéns! Trilha Concluída!",
    "completedDescription": "Você completou todos os cursos desta trilha de aprendizado."
  },
  "list": {
    "searchPlaceholder": "Buscar trilhas...",
    "difficultyPlaceholder": "Dificuldade",
    "tagPlaceholder": "Tag",
    "allTags": "Todas Tags",
    "statusPlaceholder": "Status",
    "sortPlaceholder": "Ordenar",
    "sort": {
      "title": "Título",
      "difficulty": "Dificuldade",
      "duration": "Duração",
      "popularity": "Popularidade",
      "progress": "Progresso"
    },
    "filter": {
      "all": "Todas",
      "notStarted": "Não iniciadas",
      "inProgress": "Em progresso",
      "completed": "Concluídas"
    },
    "resultsCount_one": "{{count}} trilha encontrada",
    "resultsCount_zero": "{{count}} trilhas encontradas",
    "resultsCount_other": "{{count}} trilhas encontradas",
    "activeSearch": "Busca: {{value}}",
    "activeDifficulty": "Dificuldade: {{value}}",
    "activeTag": "Tag: {{value}}",
    "activeStatus": "Status: {{value}}",
    "clearFilters": "Limpar filtros",
    "emptyTitle": "Nenhuma trilha encontrada",
    "emptyFiltered": "Tente ajustar os filtros de busca.",
    "emptyDescription": "Não há trilhas disponíveis no momento."
  }
}
